export type IDays = 'monday' | 'tuesday' | 'wednesday' | 'thursday' | 'friday' | 'saturday' | 'sunday';

export type ISchedule = Record<IDays, number[][]>;

export enum ScheduleAvailabilityTypeEnum {
  always = 'always',
  specificDays = 'specificDays',
}
